import React, { useRef, useState, useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Form } from "react-bootstrap";
import UserImg from "../../assets/images/providerProfileImg.png";
import {
  AttachedIcon,
  BackIcon,
  BlockIcon,
  PapperBoatIcon,
} from "../Icons";
import socket from "../../socket/socket";
import { fetchImage, formatTime, getFullName } from "../../utils/common";
import {
  blockUser,
  fetchBlockStatus,
  unblockUser,
} from "../../services/hireProvider.service";
import { setLoader } from "../../slice/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../slice/authSlice";
import { toast } from "react-toastify";
import imageCompression from "browser-image-compression";
import "./Newchat.scss";

const Newchat = (props) => {
  const user = useSelector(selectUser);
  const userType = user?.userType;
  const [message, setMessge] = useState([]);
  const [input, setInput] = useState("");
  const [imageData, setImageData] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [sendingImage, setSendingImage] = useState(false);
  const [fileInput, setFileInput] = useState(null);
  const loggedInuser = localStorage.getItem("users");
  const { id } = JSON.parse(loggedInuser);
  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const [blockedStatus, setBlockedStatus] = useState([]);
  const [blockedStatusBySender, setBlockedStatusBySender] = useState([]);
  const [profileImage, setProfileImage] = useState(null);
  const [fetchedImages, setFetchedImages] = useState({});
  const [enlargedImage, setEnlargedImage] = useState(null);

  const openEnlargedView = (image) => setEnlargedImage(image);
  const closeEnlargedView = () => setEnlargedImage(null);

  useEffect(() => {
    const loadImage = async () => {
      if (props?.showChat?.profilePic) {
        try {
          const fetchedImage = await fetchImage(props.showChat.profilePic);
          setProfileImage(fetchedImage);
        } catch (error) {
          setProfileImage(UserImg);
        }
      } else {
        setProfileImage(UserImg);
      }
    };
    loadImage();
  }, [props?.showChat?.profilePic]);

  useEffect(() => {
    const fetchImages = async () => {
      const imagePromises = message.map(async (msg) => {
        if (msg?.type === "image" && msg?.image) {
          try {
            const fetchedImage = await fetchImage(msg?.image);
            return { id: msg?._id, url: fetchedImage };
          } catch {
            return { id: msg?._id, url: UserImg };
          }
        }
        return null;
      });

      const imageResults = await Promise.all(imagePromises);
      const imageMap = imageResults.reduce((acc, img) => {
        if (img) acc[img.id] = img.url;
        return acc;
      }, {});
      setFetchedImages(imageMap);
    };

    fetchImages();
  }, [message]);

  useEffect(() => {
    getBlockStatus();
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    socket.emit("get_All_Messages", props.showChat);
    socket.on("chat-message", (ele) => setMessge(ele));
  }, [props.showChat]);

  useEffect(() => {
    socket.on("chat-message2", (ele) => setMessge(ele));
  }, []);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [message]);

  const getBlockStatus = async () => {
    try {
      await dispatch(setLoader(true));
      const response = await fetchBlockStatus({ chatId: props?.showChat?._id });
      if (response?.status) {
        const blocked = response.data.chat.blockedUsers;
        setBlockedStatus(blocked.filter((b) => b.blockedBy === id));
        setBlockedStatusBySender(blocked.filter((b) => b.blockedBy !== id));
      }
      await dispatch(setLoader(false));
    } catch (err) {
      await dispatch(setLoader(false));
    }
  };

  const containsMobileNumber = (inputString) => {
    const mobilePattern = /(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/;
    return mobilePattern.test(inputString);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setSendingImage(true);
    setFileInput(file);

    const options = {
      maxSizeMB: 5,
      maxWidthOrHeight: 800,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageData(reader.result);
        setPreviewImage(reader.result);
        setSendingImage(false);
      };
      reader.readAsDataURL(compressedFile);
    } catch (error) {
      toast.error("Image processing failed.");
      setSendingImage(false);
    }
  };

  const sendMessage = () => {
    if (!input && !imageData) return;
    if (input && containsMobileNumber(input)) {
      toast.warning("This message is prohibited for sending.");
      return;
    }

    const data = {
      roomID: props.showChat._id,
      message: input,
      senderID: id,
      receiversID: props.showChat.reciverID,
      type: input ? "text" : "image",
      image: input ? null : imageData,
      userType,
    };

    socket.emit("send-new-message", data);
    setInput("");
    setImageData(null);
    setPreviewImage(null);
    setFileInput(null);
  };

  const sendText = (e) => {
    const code = e.keyCode || e.which;
    if (!input) return;
    if (code === 13) sendMessage();
  };

  const fetchBlockUser = async () => {
    try {
      await dispatch(setLoader(true));
      await blockUser({
        chatId: props?.showChat?._id,
        blockingUserId: id,
        blockedUserId: props?.showChat?.reciverID,
      });
      toast.success("User blocked.");
      getBlockStatus();
      await dispatch(setLoader(false));
    } catch {
      await dispatch(setLoader(false));
    }
  };

  const fetchUnblockUser = async () => {
    try {
      await dispatch(setLoader(true));
      await unblockUser({
        chatId: props?.showChat?._id,
        unblockingUserId: id,
        unblockedUserId: props?.showChat?.reciverID,
      });
      toast.success("User unblocked.");
      getBlockStatus();
      await dispatch(setLoader(false));
    } catch {
      await dispatch(setLoader(false));
    }
  };

  return !props?.showChat?._id ? (
    <div className="chat-right"></div>
  ) : (
    <div className={`chat-right ${props.showChat?._id ? "show" : ""}`}>
      <div className="chat-header">
        <div className="contact-profile">
          <div className="back-btn"><BackIcon /></div>
          <div className="contact-profile-img-wrap">
            <div className="contact-profile-img">
              <img src={profileImage} alt="User" />
            </div>
          </div>
          <div className="contact-profile-name text-truncate">
            {getFullName(props?.showChat?.firstName, props?.showChat?.lastName)}
            {blockedStatusBySender?.length ? " has blocked you." : ""}
          </div>
        </div>
        <div className="dropdown-wrapper">
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              <div className="circle"></div>
              <div className="circle"></div>
              <div className="circle"></div>
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <ul>
                <li>
                  <i><BlockIcon /></i>
                  {blockedStatus?.length ? (
                    <span onClick={fetchUnblockUser}>Unblock</span>
                  ) : (
                    <span onClick={fetchBlockUser}>Block</span>
                  )}
                </li>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="main-chat-area">
        <div className="chat-area" ref={scrollRef}>
          {message.map((msg, index) => {
            const isSender = id === msg?.senderID?._id;
            return (
              <div
                className={isSender ? "sender" : "reciver"}
                key={index}
                onClick={() => msg?.type === "image" && openEnlargedView(fetchedImages[msg?._id])}
                style={{ cursor: msg?.type === "image" ? "pointer" : "" }}
              >
                <div className={isSender ? "sender-message" : "reciver-message"}>
                  {msg?.type === "image" ? (
                    <img src={fetchedImages[msg?._id]} style={{ height: "300px", width: "300px" }} />
                  ) : (
                    msg?.message
                  )}
                </div>
                <div className={isSender ? "sender-time" : "reciver-time"}>
                  {formatTime(msg?.createdAt)}
                </div>
              </div>
            );
          })}
        </div>

        <div className="chat-footer-area">
          <div className="chat-footer">
            {previewImage && (
              <div className="image-preview-box">
                <img
                  src={previewImage}
                  alt="preview"
                  style={{ width: "100px", height: "100px", objectFit: "cover" }}
                />
                <span
                  onClick={() => {
                    setPreviewImage(null);
                    setImageData(null);
                    setFileInput(null);
                  }}
                  style={{
                    cursor: "pointer",
                    color: "red",
                    fontWeight: "bold",
                    marginLeft: "10px",
                  }}
                >
                  ✖
                </span>
              </div>
            )}
            {!previewImage && (
              <Form.Control
                as="textarea"
                value={input}
                disabled={blockedStatus?.length || blockedStatusBySender?.length}
                onChange={(e) => setInput(e.target.value)}
                onKeyPress={sendText}
                rows={3}
              />
            )}
            <div className="chat-footer-action">
              <div className="attached-file">
                <AttachedIcon />
                <input
                  type="file"
                  accept="image/*"
                  disabled={blockedStatus?.length || blockedStatusBySender?.length}
                  onChange={handleFileChange}
                />
              </div>
              <div className="send-message">
                <Button
                  disabled={
                    (blockedStatus?.length || blockedStatusBySender?.length) || sendingImage
                  }
                  variant="primary"
                  type="submit"
                  onClick={sendMessage}
                >
                  <PapperBoatIcon />
                </Button>
              </div>
            </div>
          </div>
        </div>

        {enlargedImage && (
          <div className="enlarged-view-overlay" onClick={closeEnlargedView}>
            <div className="enlarged-view">
              <img src={enlargedImage} alt="Enlarged" className="enlarged-image" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Newchat;